import React from 'react';
import '../../assets/css/Home.page.css';
import { Accordion, AccordionSummary, AccordionDetails, useMediaQuery, Typography, Box, Grid, Divider, Link } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PoweredByDQLogo from '../../assets/images/PoweredByDQ.png';
import GCFLogo from '../../assets/images/GCFLogo.png';
import { useTheme } from '@mui/material/styles';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ backgroundColor: '#003C69', color: '#fff', py: 4, px: 0 }}>
            {/* Main content with 4 columns */}
            <Grid container spacing={4} width="100vw" sx={{mt:"5px",ml:'auto'}}>
                {/* Logo column (first column) */}
                <Grid item xs={12} md={5} pl={{xs:0, sm:undefined}} sx={{paddingTop:'0px !important'}}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                        flexWrap: 'nowrap',
                        gap: 2
                    }}>
                        <Box
                            component="img"
                            src={GCFLogo}
                            alt="Logo 1"
                            sx={{
                                height: {xs:60, sm:60, md:60, lg: 90},
                            }}
                        />
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                                backgroundColor: '#fff',
                                width: 3,
                                mt:'auto',
                                mb:'auto',
                                height: 80,
                            }}
                        />
                        <Box
                            component="img"
                            src={PoweredByDQLogo}
                            alt="PoweredByDQLogo"
                            sx={{
                                height: {xs:58, sm:58, md:56, lg: 80},
                            }}
                        />
                    </Box>
                </Grid>

                {/* Contact Info (second column) */}
                <Grid item xs={12} md={3} sx={{ pr:{xs:'0px', sm:'60px'}, pl: { xs: '10px !important', sm: 0 }, pt: { xs: '10px !important', sm: '40px !important' },  ml: isMobile ? 0 : 'auto', }}>
                    {isMobile ? (
                        <Accordion sx={{ backgroundColor: 'transparent', color: '#fff', boxShadow:'none'}}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>
                                <Typography variant="h6">Contact Information</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {/*<Typography variant="body2">Phone: (123) 456-7890</Typography>*/}
                                <Typography variant="body2">Email: Info@gcforum.org</Typography>
                                <Typography variant="body2">Riyadh, Laysen Valley, Building (12), King Khalid Road, Umm Al Hamam District, Postal Code No. (13329), Kingdom of Saudi Arabia</Typography>
                            </AccordionDetails>
                        </Accordion>
                    ) : (
                        <>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                Contact Information
                            </Typography>
                            {/*<Typography variant="body2">Phone: (123) 456-7890</Typography>*/}
                            <Typography variant="body2">Email: Info@gcforum.org</Typography>
                            <Typography variant="body2">Riyadh, Laysen Valley, Building (12), King Khalid Road, Umm Al Hamam District, Postal Code No. (13329), Kingdom of Saudi Arabia</Typography>
                        </>
                    )}
                </Grid>

                {/* Navigation Links (third column) */}
                <Grid item xs={12} md={2} sx={{ pl: { xs: '10px !important', sm: 0 }, pt: { xs: '10px !important', sm: '40px !important' }, }}>
                    {isMobile ? (
                        <Accordion sx={{ backgroundColor: 'transparent', color: '#fff', boxShadow:'none' }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>
                                <Typography variant="h6">Quick Links</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {[
                                    { label: 'Privacy Policy', href: '/privacy' },
                                    // { label: 'Terms and Conditions', href: '/terms' },
                                    // { label: 'Methodology', href: '/methodology' },
                                    // { label: 'FAQ', href: '/faq' },
                                ].map(link => (
                                    <Typography key={link.label} variant="body2">
                                        <Link href={link.href} underline="hover" color="inherit">
                                            {link.label}
                                        </Link>
                                    </Typography>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    ) : (
                        <>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                Quick Links
                            </Typography>
                            {[
                                { label: 'Privacy Policy', href: '/privacy' },
                                // { label: 'Terms and Conditions', href: '/terms' },
                                // { label: 'Methodology', href: '/methodology' },
                                // { label: 'FAQ', href: '/faq' },
                            ].map(link => (
                                <Typography key={link.label} variant="body2">
                                    <Link href={link.href} underline="hover" color="inherit">
                                        {link.label}
                                    </Link>
                                </Typography>
                            ))}
                        </>
                    )}
                </Grid>

                {/* Legal Links (fourth column) */}
                {/*<Grid item xs={12} md={2} sx={{ pl: { xs: '10px !important', sm: 0 }, pt: { xs: '10px !important', sm: '40px !important' },  }}>*/}
                {/*    {isMobile ? (*/}
                {/*        <Accordion sx={{ backgroundColor: 'transparent', color: '#fff' , boxShadow:'none'}}>*/}
                {/*            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>*/}
                {/*                <Typography variant="h6">Legal Links</Typography>*/}
                {/*            </AccordionSummary>*/}
                {/*            <AccordionDetails>*/}
                {/*                {[*/}
                {/*                    { label: 'Cookie Policy', href: '/cookies' },*/}
                {/*                    { label: 'Disclaimers', href: '/disclaimers' },*/}
                {/*                    { label: 'Site Map', href: '/sitemap' },*/}
                {/*                    { label: 'Careers', href: '/careers' },*/}
                {/*                ].map(link => (*/}
                {/*                    <Typography key={link.label} variant="body2">*/}
                {/*                        <Link href={link.href} underline="hover" color="inherit">*/}
                {/*                            {link.label}*/}
                {/*                        </Link>*/}
                {/*                    </Typography>*/}
                {/*                ))}*/}
                {/*            </AccordionDetails>*/}
                {/*        </Accordion>*/}
                {/*    ) : (*/}
                {/*        <>*/}
                {/*            <Typography variant="h6" sx={{ mb: 1 }}>*/}
                {/*                Legal*/}
                {/*            </Typography>*/}
                {/*            {[*/}
                {/*                { label: 'Cookie Policy', href: '/cookies' },*/}
                {/*                { label: 'Disclaimers', href: '/disclaimers' },*/}
                {/*                { label: 'Site Map', href: '/sitemap' },*/}
                {/*                { label: 'Careers', href: '/careers' },*/}
                {/*            ].map(link => (*/}
                {/*                <Typography key={link.label} variant="body2">*/}
                {/*                    <Link href={link.href} underline="hover" color="inherit">*/}
                {/*                        {link.label}*/}
                {/*                    </Link>*/}
                {/*                </Typography>*/}
                {/*            ))}*/}
                {/*        </>*/}
                {/*    )}*/}
                {/*</Grid>*/}
            </Grid>

            {/* Copyright */}
            <Box sx={{
                pt: 4,
                textAlign: 'center',
            }}>
                <Typography variant="body2">
                    © {currentYear} CPC Index. All Rights Reserved.
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;